import styled from 'styled-components';
import colors from 'styles/colors';
import { NavLink } from 'react-router-dom';

export const Title = styled.h2`
  font-size: 16px;
  margin-bottom: 22px;
  font-weight: 600;
`;

export const SideMenuContainer = styled.div`
  z-index: 5;
  flex-basis: 180px;
  flex-shrink: 0;
  border-left: 0;
`;

export const NavItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const NavItem = styled(NavLink)<{ disabled?: boolean }>`
  color: ${colors.primary};
  text-decoration: none;
  transition: text-shadow 0.3s;
  padding: 8px 16px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  transition: 0.15s color ease-in-out;
  transition: 0.15s background-color ease-in-out;
  transition: 0.15s border ease-in-out;
  width: 100%;
  border: 1px solid #fff0;

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    color: ${colors.blue};
    background-color: ${colors.lightBackground};
  }
`;

export const ExpandableTitle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${colors.gray55};
  margin-bottom: 15px;
  text-decoration: none;
  transition: text-shadow 0.3s;
  font-size: 13px;
  font-weight: 600;
  transition: 0.15s color ease-in-out;

  i {
    margin-left: 15px;
  }

  &:hover {
    color: ${colors.primary};
  }
`;

export const Icon = styled.i`
  font-size: 8px;
  margin-left: 10px;
`;

export const ExpandableItems = styled.div<{ visible?: boolean }>`
  ${(props) =>
    props.visible
      ? `
        display: flex;
    `
      : `display: none;`}

  flex-direction: column;
  margin-left: 18px;

  a {
    margin-bottom: 10px;
  }
`;
